import { StyledList } from "../styledList";
import DummyTile from "./DummyTile";

const Loading = () => {
  return (
    <StyledList>
      <DummyTile />
      <DummyTile />
      <DummyTile />
      <DummyTile />
      <DummyTile />
      <DummyTile />
      <DummyTile />
    </StyledList>
  );
};

export default Loading;
